import { passwordResetRequestSchema, routes } from '@pmai/contracts';
import { Alert, Button, TextField } from '@pmai/ui';
import { useTranslation } from 'react-i18next';
import { useApiMutation } from '../../shared/api/hooks';
import { bind, useZodForm } from '../../shared/forms/form';
import { useErrorText } from '../../shared/i18n';
import { AuthCard, BackToLogin } from './auth-layout';

/** FR-AUTH-103: the same answer for known and unknown e-mails. */
export function ForgotPasswordPage() {
  const { t } = useTranslation();
  const errorText = useErrorText();
  const form = useZodForm(passwordResetRequestSchema, { defaultValues: { email: '' } });
  const request = useApiMutation(routes.auth.passwordResetRequest);

  return (
    <AuthCard title={t('auth.forgot.title')} footer={<BackToLogin />}>
      {request.isSuccess ? (
        <Alert tone="success">{t('auth.forgot.done')}</Alert>
      ) : (
        <form
          noValidate
          className="flex flex-col gap-4"
          onSubmit={form.handleSubmit((body) => request.mutate({ body }))}
        >
          <p className="text-sm text-ink-muted">{t('auth.forgot.text')}</p>
          {request.error && <Alert tone="danger">{errorText(request.error)}</Alert>}
          <TextField
            label={t('auth.email')}
            type="email"
            autoComplete="email"
            required
            {...bind(form, 'email')}
          />
          <Button type="submit" loading={request.isPending}>
            {t('auth.forgot.submit')}
          </Button>
        </form>
      )}
    </AuthCard>
  );
}
